import type {
  GetAgentsQuery,
  GetAgentQuery,
  GetAgentQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_AGENTS: TypedDocumentNode<GetAgentsQuery> = gql`
  query GetAgents {
    agents {
      agents {
        id
        userId
        name
        cron
        processorId
        parameters
        enabled
        lastRunAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_AGENT: TypedDocumentNode<
  GetAgentQuery,
  GetAgentQueryVariables
> = gql`
  query GetAgent($id: String!) {
    agent(id: $id) {
      id
      userId
      name
      cron
      processorId
      parameters
      enabled
      lastRunAt
      createdAt
      updatedAt
    }
  }
`;
